import React, { useState, useEffect, useCallback } from 'react';
import TimeSlider from '../TimeSlider/timeSlider';
import MapComponentSingle from '../MapComponent/MapComponentSingle';
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const History = ({ employeeData, user_id }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [coordinates, setCoordinates] = useState(null);

  const getCoordinates = useCallback(async () => {
    if (selectedDate && selectedTime) {
      const timestamp = new Date(`${selectedDate} ${selectedTime}`).getTime() / 1000;
      try {
        const response = await axiosInstance.get(`website/employee/coordinates/${user_id}?timestamp=${timestamp}`);
        setCoordinates(response.data);
        logger.debug(response.data, "AAAAAA");
      } catch (error) {
        logger.error('Error fetching coordinates:', error);
      }
    }
  }, [selectedDate, selectedTime, user_id]);

  useEffect(() => {
    getCoordinates();
  }, [getCoordinates]);

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
    logger.debug('Selected Time:', time);
  };

  return (
    <div className="history">
      {employeeData && coordinates && (
        <MapComponentSingle
          employee={{ x: coordinates.x, y: coordinates.y, r: coordinates.r }}
          scale={0.5}
          selectedTime={selectedTime}
          building_id={coordinates.building_id}
          floor={coordinates.floor}
        />
      )}
      <div>
        <p>История перемещений</p>
        <p>
          Дата
          <input className="calendar" type="date" onChange={handleDateChange} />
        </p>
        <p>
          Время прихода: {employeeData?.time?.begin} Время ухода: {employeeData?.time?.end}
        </p>
        <TimeSlider date={selectedDate} id={user_id} onTimeChange={handleTimeChange} />
      </div>
    </div>
  );
};

export default History;
